module.exports = __webpack_public_path__ + "img/guys-soccer-goalie-gloves-tattoo-on-forearm.jpg";